(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4737],{

/***/ 74385:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wishlist",
      function () {
        return __webpack_require__(89628);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_product_card_product_card__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91740);
/* harmony import */ var _layout_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16559);
/* harmony import */ var _store_slices_wishlist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78271);
/* harmony import */ var _styles_cart_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17806);
/* harmony import */ var _styles_cart_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_cart_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);
/* harmony import */ var _lib_unbxd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22236);










var Wishlist = function() {
    var wishlistState = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(_store_slices_wishlist__WEBPACK_IMPORTED_MODULE_3__/* .selectWishlist */ .jq);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        setTimeout(function() {
            var ref;
            (0,_lib_unbxd__WEBPACK_IMPORTED_MODULE_7__/* .unbxdCusEngTrackEvent */ .$z)("Wishlist items ", {
                source: "web",
                platform: "senco",
                total_prqt: wishlistState.items.length,
                items: (ref = wishlistState.items) === null || ref === void 0 ? void 0 : ref.map(function(v) {
                    var ref, ref1, ref2;
                    return {
                        prid: v.id,
                        prqt: 1,
                        variant_id: v.priceId,
                        image: v.image,
                        product_name: v.title,
                        category: ((ref = v.categories) === null || ref === void 0 ? void 0 : ref.length) ? (ref1 = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(v.categories).reverse()[0]) === null || ref1 === void 0 ? void 0 : ref1.name : "",
                        product_url: "".concat("https://sencogoldanddiamonds.com", "/jewellery/").concat(v.slug),
                        selling_price: v.price,
                        discounted_price: (ref2 = v.discount) === null || ref2 === void 0 ? void 0 : ref2.price
                    };
                })
            });
        }, 500);
    }, [
        wishlistState
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_styles_cart_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cart_page),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "row mt-5 mb-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-md-12 mb-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: "text-center",
                            children: "WISHLIST"
                        })
                    }),
                    wishlistState.items.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: wishlistState.items.map(function(product) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-lg-3 col-md-6 col-6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_product_card_product_card__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    product: product
                                })
                            }, product.id);
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "col-12",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-center",
                                children: "Your wishlist is empty"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    href: "/",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        "aria-label": " Continue Shopping",
                                        role: "button",
                                        className: "btn btn-outline-info",
                                        children: "Continue Shopping"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
Wishlist.getLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Wishlist);


/***/ }),

/***/ 17806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border":"cart_border___wtYP","container":"cart_container__GMftB"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,6646,1251,9774,2888,179], function() { return __webpack_exec__(74385); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);